import $ from 'jquery';
import 'jquery.scrollbar';
import 'slick-carousel';
declare const Drupal;
declare const once;
$(() => {
  /**
   * Activity feed toggle
   */
  // Check if the member type header exists
  if ($('.member-feed-header').length) {
    Drupal.behaviors.activityFeedToggle = {
      attach: (context): void => {
        $('.toggle-activities-button', context).on('click', function toggleActivitiesButtonClick(): void {
          const $self = $(this);
          if (!$self.hasClass('active')) {
            $('.toggle-activities-button').toggleClass('active');
            $('#activity-feeds').slick('slickGoTo', $self.data('feed') === 'member' ? '0' : '1');
          }
        });
      },
    };
  }

  /**
   * Add hover for touch devices
   */
  Drupal.behaviors.touchHover = {
    attach: function attach(context): void {
      const elements = once('initTouchHover', '.touch-hover', context);
      elements.forEach(function eachTouchHover(index, element) {
        const $touchItem = $(element);

        $touchItem.on('mouseenter', function touchItemMouseEnter(): void {
          $(this).addClass('hover');
        });
        $touchItem.on('mouseleave', function touchItemMouseLeave(): void {
          $(this).removeClass('hover');
        });

        //Touch support for work linkbox hover
        $touchItem.on('touchstart', (): void => {
          $touchItem.removeClass('hover');
          $(this).addClass('hover');
        });
      });
    },
  };

  // Init custom scrollbars on media feed
  $('.media-feed-scroll').scrollbar();

  $('#articles-slideshow').slick({
    dots: true,
    infinite: true,
    speed: 300,
    fade: true,
    cssEase: 'linear',
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000,
  });

  const $activityFeeds = $('#activity-feeds');
  if ($activityFeeds.length) {
    $activityFeeds.slick({
      swipe: false,
      arrows: false,
      dots: false,
      infinite: false,
      speed: 300,
      fade: true,
      cssEase: 'linear',
      adaptiveHeight: true,
      autoplay: false,
    });
  }
});
